import { render, staticRenderFns } from "./Acknowledgements.vue?vue&type=template&id=e1a24896"
import script from "./Acknowledgements.vue?vue&type=script&lang=js"
export * from "./Acknowledgements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports